var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info__row user-info__account-funds"},[_vm._v("Доступно средств:\n\t"),_c('span',[_vm._v(_vm._s(_vm.balance))])])}
var staticRenderFns = []

export { render, staticRenderFns }